module.exports = __webpack_public_path__ + "static/img/help_02class_06.f322110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_02class_06.png
// module id = 686
// module chunks = 140